export default __webpack_public_path__ + "static/media/Weber.bddb4b53.png";